import { Navigate, useLocation } from 'react-router-dom';
import { useAuthUser } from '../services/authSync';

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    // Re-renders on auth changes (e.g. sign-out in another tab, R0).
    const user = useAuthUser();

    if (!user) {
        // Redirect them to the /login page, but save the current location they were
        // trying to go to when they were redirected. This allows us to send them
        // along to that page after they login, which is a nicer user experience
        // than dropping them off on the home page.
        return <Navigate to="/?login=true" state={{ from: location }} replace />;
    }

    return children;
};

export default ProtectedRoute;
